import {
  PRESENTATION_SECONDS,
  QUESTIONS_SECONDS,
  TPresentationScores,
} from './presentationRules';

/**
 * Rascunho da banca por equipe (FE-64): notas ainda não salvas e o
 * cronômetro. O cronômetro guarda QUANDO começou, não quantos segundos já
 * contou: trocar de aba, recarregar ou o celular dormir não perde o tempo.
 */
export interface ITimerState {
  /** Instante (ms) em que a contagem atual começou; null = parado. */
  started_at: number | null;
  /** Tempo já contado antes da última pausa, em ms. */
  accumulated_ms: number;
}

export interface ITeamDraft {
  /** Notas digitadas e ainda não salvas; ausente = usar as da API. */
  scores?: TPresentationScores;
  timer?: ITimerState;
}

export type TDrafts = Record<string, ITeamDraft>;

export const IDLE_TIMER: ITimerState = { started_at: null, accumulated_ms: 0 };

const TOTAL_SECONDS = PRESENTATION_SECONDS + QUESTIONS_SECONDS;

export function elapsedSeconds(timer: ITimerState, now: number): number {
  const running = timer.started_at === null ? 0 : now - timer.started_at;
  const seconds = Math.floor(
    (timer.accumulated_ms + Math.max(0, running)) / 1000,
  );
  return Math.min(seconds, TOTAL_SECONDS);
}

export const isRunning = (timer: ITimerState): boolean =>
  timer.started_at !== null;

export function startTimer(timer: ITimerState, now: number): ITimerState {
  return isRunning(timer) ? timer : { ...timer, started_at: now };
}

export function pauseTimer(timer: ITimerState, now: number): ITimerState {
  if (timer.started_at === null) return timer;
  return {
    started_at: null,
    accumulated_ms: timer.accumulated_ms + Math.max(0, now - timer.started_at),
  };
}

export const storageKey = (tournamentId: string): string =>
  `presentation-drafts:${tournamentId}`;

/** Lê os rascunhos; sem armazenamento (aba anônima) ou JSON quebrado = vazio. */
export function readDrafts(tournamentId: string): TDrafts {
  try {
    const raw = window.sessionStorage.getItem(storageKey(tournamentId));
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function writeDrafts(tournamentId: string, drafts: TDrafts): void {
  try {
    window.sessionStorage.setItem(
      storageKey(tournamentId),
      JSON.stringify(drafts),
    );
  } catch {
    // Sem armazenamento: o rascunho fica só em memória nesta tela.
  }
}
